<template>
  <v-btn
    v-bind="{
      height: 40,
      rounded: true,
      block: true,
      variant: 'flat',
      ...$props,
      ...$attrs,
    }"
    :color="isActive
      ? brandPrimary
      : bgCanvas"
    :class="['dppl-dropdown-button', { 'text-white': isActive }]"
  >
    <slot />
  </v-btn>
</template>
<script>
import { useColors } from '@/composables/colors';

export default {
  name: 'DpplDropdownButton',
  props: {
    isActive: { default: false, type: Boolean },
  },
  setup() {
    const { brandPrimary, bgCanvas } = useColors();

    return { brandPrimary, bgCanvas };
  },
};
</script>
<style scoped lang="less">
.dppl-dropdown-button {
  display: flex;
  align-items: center;
}
.v-btn.v-size--default {
  font-size: 12px;
  font-weight: 400;
  text-transform: initial;
}
.v-btn:hover:before {
  opacity: 0;
  transition: opacity .2s cubic-bezier(.4,0,.6,1);
}
.v-btn.v-btn--disabled {
  color: @text-darkest !important;
  background-color: @white !important;
  opacity: .4;
  &.v-btn--has-bg {
    background-color: @white !important;
  }
}

:deep(.v-btn__content) {
  color: @text-darkest;

  span {
    text-transform: capitalize;
  }
}

.v-btn:focus::before {
  opacity: 0 !important;
}
</style>
